!function(e,r){"object"==typeof exports&&"object"==typeof module?module.exports=r():"function"==typeof define&&define.amd?define([],r):"object"==typeof exports?exports.storeblocks=r():e.storeblocks=r()}(self,(()=>(()=>{"use strict";var e={279:(e,r,o)=>{o.d(r,{Container:()=>d,Label:()=>l,NativeSelect:()=>s,SelectBase:()=>i});const t=require("styled-components");var n=o.n(t);const i=n().div.attrs({className:"select"})`
  display: inline-flex;
  flex-direction: column;
  position: relative;

  color: var(--color-on--background);
  font-family: 'Open Sans';
  font-size: 16px;
  line-height: 24px;

  &[aria-disabled='true'] {
    color: var(--color-disabled);
  }

  ${({fluid:e})=>e&&t.css`
      width: 100%;
      max-width: 100%;

      & > ${d} {
        width: 100%;

        & > select {
          width: 100%;
        }
      }
    `}

  & > .hint {
    margin: -8px 0 16px 0;
  }
`,l=n().label`
  display: flex;
  align-items: center;

  font-weight: 600;
  line-height: 24px;
  word-wrap: break-word;

  margin-bottom: 16px;
`,a=e=>{var r,o;return t.css`
  padding-top: 0;
  padding-right: calc(40px - ${null!==(r=null==e?void 0:e.offset)&&void 0!==r?r:0}px);
  padding-bottom: 0;
  padding-left: calc(8px - ${null!==(o=null==e?void 0:e.offset)&&void 0!==o?o:0}px);
`},s=n().select`
  /* reset start */
  appearance: none;
  background: var(--color-on-primary);
  border: 1px solid var(--color-on-background);
  padding: 0 1em 0 0;
  margin: 0;

  font-family: inherit;
  font-size: inherit;
  cursor: inherit;
  line-height: inherit;
  color: var(--color-on-background);
  /* reset end */

  position: relative;
  height: 40px;
  ${a()}
  border-radius: 2px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:focus {
    outline: none;
    border: 2px solid var(--color-selection);
    ${a({offset:1})}
  }

  &:focus-visible {
    border: 2px solid var(--color-selection);
  }

  &:disabled {
    border-color: var(--color-disabled);
    color: var(--color-disabled);
    background: var(--color-on-primary);
    cursor: not-allowed;
  }

  & > option {
    font-family: 'Open Sans';
  }

  ${({small:e,large:r})=>e?t.css`
        width: 96px;
      `:r?t.css`
        width: 288px;
      `:t.css`
      width: 148px;
    `};

  ${({error:e})=>e&&t.css`
      border: 3px solid var(--color-error-accent);
      /* Offset the padding with 2px since the error border is
        2px larger than in the normal state. This is to prevent the
        text from shifting by 2px when it is in error state. */
      ${a({offset:2})}
    `}
`,d=n().div`
  position: relative;
  display: flex;
  align-self: flex-start;

  & > i {
    position: absolute;
    bottom: 12px;
    right: 16px;
    pointer-events: none;
    font-size: 16px;
    line-height: 16px;
  }
`}},r={};function o(t){var n=r[t];if(void 0!==n)return n.exports;var i=r[t]={exports:{}};return e[t](i,i.exports,o),i.exports}o.n=e=>{var r=e&&e.__esModule?()=>e.default:()=>e;return o.d(r,{a:r}),r},o.d=(e,r)=>{for(var t in r)o.o(r,t)&&!o.o(e,t)&&Object.defineProperty(e,t,{enumerable:!0,get:r[t]})},o.o=(e,r)=>Object.prototype.hasOwnProperty.call(e,r),o.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var t={};return(()=>{o.r(t),o.d(t,{Select:()=>b,default:()=>u});const e=require("react");var r=o.n(e);const n=require("@storeblocks/icon"),i=require("@storeblocks/inline-alert");var l=o.n(i);const a=require("@storeblocks/hint");var s=o.n(a);const d=require("@storeblocks/popover");var c=o(279),p=function(e,r){var o={};for(var t in e)Object.prototype.hasOwnProperty.call(e,t)&&r.indexOf(t)<0&&(o[t]=e[t]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(t=Object.getOwnPropertySymbols(e);n<t.length;n++)r.indexOf(t[n])<0&&Object.prototype.propertyIsEnumerable.call(e,t[n])&&(o[t[n]]=e[t[n]])}return o};function b(e){var{id:o,name:t,label:i="",hint:a="",placeholder:b="",small:u=!1,medium:f=!0,large:v=!1,fluid:m=!1,disabled:h=!1,error:g="",options:x,value:y,onChange:w,hintProps:O={},labelProps:P={},inputProps:j={},attentionProps:S,labelPopoverProps:$}=e,k=p(e,["id","name","label","hint","placeholder","small","medium","large","fluid","disabled","error","options","value","onChange","hintProps","labelProps","inputProps","attentionProps","labelPopoverProps"]);const E=`${o}-select-label`,q=`${o}-select-error`;return r().createElement(c.SelectBase,Object.assign({fluid:m,"aria-disabled":h},k),i&&r().createElement(c.Label,Object.assign({id:E,htmlFor:o},P),i,$&&r().createElement(d.Popover,Object.assign({},$),$.children)),a&&r().createElement(s(),Object.assign({},O),a),r().createElement(c.Container,null,r().createElement(c.NativeSelect,Object.assign({id:o,name:t,small:u,medium:f,large:v,fluid:m,value:y,onChange:e=>function(e){const r=x.find((({value:r})=>e.target.value===r));w(e,r)}(e),disabled:h,error:g,"aria-invalid":!!g,"aria-describedby":`${E} ${q}`},j),b&&r().createElement("option",{value:"",disabled:!0,hidden:!0},b),x.map((e=>r().createElement("option",Object.assign({key:e.label,value:e.value},e),e.label)))),r().createElement(n.SystemIcon,{name:"arrow-drop-down",size:16})),g&&"string"==typeof g?r().createElement(l(),Object.assign({id:q,title:g,variant:"error","aria-label":`Error - ${g}`},S)):null)}const u=b})(),t})()));
//# sourceMappingURL=index.js.map